import React, { Component } from "react";
import { Redirect } from "react-router";
import { connect } from 'react-redux';
import uuid from "uuid";

import { roles } from '../../constants';
//import { userService } from '../../services';
import { alertActions } from '../../modules/alert';
import { userinfoActions } from '../../modules/userinfo';
import { codemngActions } from '../../modules/codemng';

import Loader from 'react-loader-spinner'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

class Home extends Component {
    constructor(props) {
        super(props);

        if(props.user) {
            props.storeCodes();

            if(!props.myInfo)
                props.getUserinfo();
        }
    }

    componentDidMount = () => {
        //this.getStateMyInfo();
    }

    redirectUrl = (url) => {
        return <Redirect to={url} />
    }

    reloadHomeUrl = () => {
        let linkTarget = {
            pathname: "/home",
            key: uuid(),
            state: {
                applied: true
            }
        };
        return this.redirectUrl(linkTarget);
    }

    render(){
        const { user, myInfo } = this.props;

        let linkTarget = {
            pathname: "",
            key: uuid(),
            state: {
                applied: true
            }
        };

        if(user) {
            if(myInfo) {
                if(myInfo.myRole === roles.userRole) {
                    //관리사무소
                    linkTarget.pathname = '/opbstate';
                    linkTarget.state = {siteID: myInfo.siteID};
                } else {
                    linkTarget.pathname = '/dashboard';
                }

                return this.redirectUrl(linkTarget);
            } else {
                return <Loader
                    type="Rings"
                    color="#00BFFF"
                    height={'50%'}
                    width={'50%'}
                    style={{'textAlign': 'center', 'marginLeft':'auto', 'marginRight':'auto'}}
                />
            }
        }else 
            return this.redirectUrl("/login");
    }
}

function mapState(state) {
    const { authentication, alert, userinfo } = state;
    const { user } = authentication;
    const myInfo = userinfo.item;
    return { alert, user, myInfo };
}

const actionCreators = {
    clearAlerts: alertActions.clear,
    getUserinfo: userinfoActions.getUserinfo,
    storeCodes: codemngActions.storeCodes,
};

export default connect(mapState, actionCreators)(Home);